<template>
    <b-card class="mb-2">
        <b-row>
            <b-col>
                <h4 class="card-title mb-0">Intäkter & utgifter</h4>
                <div v-if="date" class="small text-muted">{{dateLabel}}</div>
            </b-col>
            <b-col>
               <div class="float-right d-none d-md-block">
                    <DateCarousel :date=this.$moment() :type=dateType @onDateChanged="onDateChanged" />
                </div>                
                <div>
                <b-button-group class="float-right mr-1">
                    <b-button :pressed=monthButtonEnabled @click="revenueMonthButtonClicked">Månad</b-button>
                    <b-button :pressed=yearButtonEnabled @click="revenueYearButtonClicked">År</b-button>
                </b-button-group>
                </div>
            </b-col>
            
        </b-row>
        <monthly-revenue-chart v-if="monthButtonEnabled" :key="monthlyRevenueComponentIndex" :date=date class="chart-wrapper" style="height:300px;margin-top:40px;" height="300" />
        <yearly-revenue-chart v-if="yearButtonEnabled" :key="yearlyRevenueComponentIndex" :date=date class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"/>
    </b-card>
</template>

<script>
import YearlyRevenueChart from './charts/YearlyRevenueChart'
import MonthlyRevenueChart from './charts/MonthlyRevenueChart'
import DateCarousel from '../components/DateCarousel'
import { salarySpecificationService } from "../../shared/services";

export default {
    components: {
        YearlyRevenueChart,
        MonthlyRevenueChart,
        DateCarousel
    },
    computed: {
        dateLabel() {
            if(this.yearButtonEnabled) return this.date.year();
            return `${this.monthNames[this.date.month()]} ${this.date.year()}`
        },
    },
    data: function () {
        return {
            monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
            yearlyRevenueComponentIndex: 0,
            monthlyRevenueComponentIndex: 0,
            yearButtonEnabled : false,
            monthButtonEnabled: true, 
            date : null,
            dateType: 'month'
        }
    },
    mounted() {
        this.date = this.$moment();
        this.monthlyRevenueComponentIndex++;
        this.yearlyRevenueComponentIndex++;
    },
    methods: {
        revenueYearButtonClicked() {
            this.dateType = 'year';
            this.date = this.$moment();
            this.yearButtonEnabled = true;
            this.monthButtonEnabled = false;
            this.yearlyRevenueComponentIndex++;
        },
        revenueMonthButtonClicked() {
            this.dateType = 'month';
            this.date = this.$moment();
            this.monthButtonEnabled = true;
            this.yearButtonEnabled = false;
            this.monthlyRevenueComponentIndex++;
        },
        async onDateChanged(date) {
            this.date = date;
            this.monthlyRevenueComponentIndex++;
            this.yearlyRevenueComponentIndex++;
        },
    },
}
</script>

<style>

</style>